import { RegisterOptions } from 'react-hook-form';

export const isValidNumber = ( message?: string ): RegisterOptions['pattern'] => {
  return {
    value: /^[0-9]+$/,
    message: message || 'Value must be a number',
  };
};
